import { useState } from 'react'

import { useLastDefined } from '@subaio/components'

import { Container } from './Container'
import { Entry } from './Entry'
import { OrderedList } from './OrderedList'
import { Title } from './Title'

type Props = {
	headings: Array<{
		text: string
		link: string
		level: number
	}>
	pageName: string
}

export const TableOfContents = ({ headings, pageName }: Props) => {
	const [links, setLinks] = useState<Record<string, boolean>>(
		Object.fromEntries(
			headings.map((heading) => [heading.link, window.location.hash.replace('#', '') === heading.link]),
		),
	)
	const currentlyActiveLink = Object.entries(links).find(([, inView]) => inView)?.[0]
	const activeLink = useLastDefined(
		currentlyActiveLink,
		window.location.hash.replace('#', '') ?? Object.entries(links)[0][0],
	)
	if (headings.length === 0) return <div />

	return (
		<Container>
			<Title>On this page</Title>
			<OrderedList>
				{headings.map(({ text, link, level }, index) => (
					<Entry
						key={index}
						level={level}
						pageName={pageName}
						fragment={link}
						label={text}
						isActive={activeLink === link}
						setViewState={(inView) => {
							setLinks((state) => ({
								...state,
								[link]: inView,
							}))
						}}
					/>
				))}
			</OrderedList>
		</Container>
	)
}
